// extracted by mini-css-extract-plugin
export default {"container":"AppDownload_container__hUPBe","item":"AppDownload_item__3ltN+","button":"AppDownload_button__Qk6VH"};